// 支付功能相关
import { getMyAccount } from '@/api/member'
/**
 *支付数据状态存储
 */
export const state = () => {
  return {
    // 是否显示购买窗口
    isShowBuyLiveModal: false,
    // 账户剩余余额
    coinValidSum: '',
    payDetail: {},
    // 不能打开的原因, 没有支付或者加密的 noBuy noEncrypt
    type: '',
  }
}

export const actions = {
  async switchLiveStatus({ commit }, info) {
    console.log('switchLiveStatus', info)

    if (info.status) {
      const res = await getMyAccount()
      if (res.code === 0) {
        commit('SWITCH_LIVE_STATUS', {
          coinValidSum: res.data.coinValidSum,
          isShowBuyLiveModal: info.status,
          payDetail: info.item,
          type: info.type,
        })
      }
    } else {
      commit('SWITCH_LIVE_STATUS', {
        isShowBuyLiveModal: info.status,
      })
    }
  },
}

export const mutations = {
  SWITCH_LIVE_STATUS: (state, { isShowBuyLiveModal, payDetail, coinValidSum, type }) => {
    if (isShowBuyLiveModal) {
      state.payDetail = payDetail
      state.coinValidSum = coinValidSum
      state.isShowBuyLiveModal = isShowBuyLiveModal
      state.type = type
    } else {
      state.isShowBuyLiveModal = isShowBuyLiveModal
    }
  },
}
export const getters = {}
